import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

import { theme } from '../../theme';

export interface LogoIconProps {
  color?: string;
  color2?: string;
  fontSize?: string;
}

export const LogoIcon = ({
  color,
  color2,
  fontSize,
}: LogoIconProps): ReactElement => {
  // Use `color` for both if it is provided and color2 is not
  color2 = color2 ?? color ?? theme.palette.vibrant.secondary;
  color = color ?? theme.palette.vibrant.primary;

  return (
    <SvgIcon
      style={{ fontSize: fontSize || '1em' }}
      width="27.486"
      height="32.184"
      viewBox="0 0 27.486 32.184"
    >
      <path
        fill={color2}
        d="M132.58,69.638l3.158-2.785a4.622,4.622,0,0,0,.286-6.734l-.035-.036-5.153,4.544a5.8,5.8,0,0,0-1.968,4.349v3.936Z"
        transform="translate(-115.124 -53.727)"
      />
      <path
        fill={color}
        d="M55.6,10.9,54.087,9.563l1.438-1.279a5.787,5.787,0,0,0,1.957-4.348V0l-3.7,3.274-3.15,2.785A4.782,4.782,0,0,0,49.607,7.34a4.666,4.666,0,0,0-.514,1.5,4.615,4.615,0,0,0,.017,1.564,4.547,4.547,0,0,0,.557,1.489,5.193,5.193,0,0,0,1.043,1.235l3.142,2.785,3.7,3.274V15.249A5.782,5.782,0,0,0,55.6,10.9"
        transform="translate(-43.805)"
      />
      <path
        fill={color2}
        d="M10.236,141.99l-3.713-3.274-3.942-3.438-1.928-1.7-.047.1a6.812,6.812,0,0,0,1.735,7.933l.034.03,4.149,3.62,3.507,3.092,3.713,3.274v-4.311a4.964,4.964,0,0,0-1.685-3.723Z"
        transform="translate(0 -119.446)"
      />
      <path
        fill={color}
        d="M132.374,141.99l3.713-3.274,3.942-3.438,1.928-1.7.047.1a6.812,6.812,0,0,1-1.734,7.933l-.034.03-4.149,3.62-3.507,3.092-3.713,3.274v-4.311a4.963,4.963,0,0,1,1.685-3.723Z"
        transform="translate(-115.124 -119.446)"
      />
    </SvgIcon>
  );
};
